
import { Settings } from "@/config";
import { Vue } from "vue-class-component";

export default class AppFooter extends Vue {
  get appName() {
    return Settings.AppName;
  }
}
